module.exports = __webpack_public_path__ + "static/media/egypt-flag.2db4ec4b.png";